var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tp-loader"},[_c('div',{staticClass:"tp-loader__body"},[_c('div',{staticClass:"tp-loader__circle circle-front"}),_c('div',{staticClass:"tp-loader__circle circle-rear"})])])
}]

export { render, staticRenderFns }